export default "__VITE_ASSET__b5356315__"